import { render, staticRenderFns } from "./chargeRule.vue?vue&type=template&id=db01c0c8"
import script from "./chargeRule.vue?vue&type=script&lang=js"
export * from "./chargeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports